import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
export var getDefaultStyleSheet = _ref => {
  var {
    colorToken,
    designContext,
    interactiveState
  } = _ref;
  return {
    containerStyle: {
      backgroundColor: designContext.get('colors/backgrounds/transparent').toString(),
      border: 'none',
      cursor: 'pointer',
      display: 'block',
      padding: 0,
      position: 'relative',
      outline: 0,
      overflow: 'visible'
    },
    overlayStyle: {
      height: 40,
      transition: 'background-color 0.2s ease'
    },
    actionWrapperStyle: {
      marginLeft: 10,
      marginRight: 10,
      marginTop: 5,
      marginBottom: 5
    },
    actionTextStyle: _objectSpread(_objectSpread({
      color: designContext.get(colorToken ? colorToken : 'navbar/action-text-color', {
        interactiveState
      }).toString()
    }, designContext.get('navbar/action-text-style').styles()), {}, {
      WebkitFontSmoothing: 'antialiased',
      textAlign: 'left',
      wordBreak: 'break-word',
      marginBottom: 0,
      marginTop: 4
    })
  };
};
//# sourceMappingURL=getDefaultStyleSheet.js.map